export default __webpack_public_path__ + "static/N0211-17f399bc5a80e9707bf7d9300f422d43.png";